var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTamtam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0808 4.08953C25.2279 3.79287 28.4484 4.23359 31.385 5.40993C36.428 7.39182 40.5725 11.5244 42.568 16.5614C44.2303 20.6795 44.4476 25.3567 43.1988 29.6155C42.2364 32.9314 40.3858 35.9814 37.9001 38.3767C35.3531 40.8505 32.1343 42.6269 28.6786 43.4487C24.6807 44.411 20.3844 44.1101 16.5672 42.5724C11.5285 40.5785 7.39254 36.434 5.40981 31.3902C3.41596 26.4274 3.54129 20.6573 5.75845 15.7891C7.59203 11.6923 10.8568 8.25704 14.8513 6.2112C17.0958 5.04936 19.5661 4.33161 22.0808 4.08953Z",
    fill: "#536BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9091 13.7191C19.0419 12.2308 21.652 11.4406 24.2528 11.5062C26.7061 11.5437 29.1381 12.345 31.143 13.7583C33.3013 15.2706 34.9644 17.4775 35.8151 19.9725C36.717 22.5886 36.7255 25.5023 35.8407 28.1243C35.059 30.4608 33.5698 32.5544 31.6203 34.0615C29.641 35.6035 27.1851 36.5276 24.6773 36.6503C23.5956 36.7194 22.5078 36.6188 21.444 36.4133C20.2003 37.2436 18.9634 38.0841 17.7189 38.9127C17.5416 39.0457 17.2313 39.1019 17.1043 38.8734C16.996 38.6689 17.0421 38.4234 17.0301 38.2009C17.0335 36.9802 17.031 35.7604 17.0319 34.5397C14.657 32.9303 12.8541 30.4941 12.0366 27.7424C11.2762 25.2218 11.3232 22.4616 12.1824 19.9708C13.0399 17.4553 14.7243 15.2322 16.9091 13.7191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2857 24.478C22.0944 24.4772 25.9031 24.4763 29.7117 24.478C29.7074 25.7124 29.3077 26.9441 28.5626 27.9304C27.6829 29.1161 26.3276 29.9413 24.8656 30.1578C23.4924 30.3743 22.0441 30.0623 20.8839 29.2951C19.2797 28.2603 18.2755 26.3858 18.2857 24.478Z",
    fill: "#536BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamtam);
export default __webpack_public_path__ + "static/media/Tamtam.d55d157b.svg";
export { ForwardRef as ReactComponent };